export enum PasswordResetSteps {
	request = 'request',
	checkCode = 'checkCode',
	resetPassword = 'resetPassword',
}
